var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multiselect',{attrs:{"value":_vm.campaign,"options":_vm.options,"loading":_vm.$apollo.queries.options.loading,"show-labels":false,"allow-empty":false,"track-by":"id","label":"name","name":"campaign","placeholder":"Select campaign"},on:{"search-change":_vm.search,"input":_vm.setCampaign}})
}
var staticRenderFns = []

export { render, staticRenderFns }